'use strict';

const base = require('base/product/base');
const baseAddToCart = base.addToCart;
const googleAnalytics = require('./googleAnalytics');

async function handleAddToCart(addToCartData, updateCartState = false) {
    const res = await fetch(window.reactSystemData.controllers.basket.addProducts, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: 'pidsObj='+encodeURIComponent(JSON.stringify(addToCartData))
    });
    const response = await res.json();
    if (response.error) {
        console.error('addToCart.js - Error adding product(s) to bag - ', response.message);
    }
    triggerSuccessfulAddToBagEvents(response, addToCartData, updateCartState);
    return response;
}

function triggerSuccessfulAddToBagEvents(response, addToCartData, updateCartState) {
    document.body.dispatchEvent(
        new CustomEvent('reactEvent', {
            detail: {
                eventName: 'count:update',
                target: '.minicart',
                eventData: {
                    quantityTotal: response.quantityTotal,
                    minicartCountOfItems: response.minicartCountOfItems,
                }
            }
        })
    )

    let gaEventItems = [];
    addToCartData.forEach((addedData) => {
        try {
            const {pid, qty, location} = addedData;
            if (!response.cart && !response.cart.items) return;

            const matchingItem = response.cart.items.find((cartItem) => cartItem.id === pid);
            if (!matchingItem) return;

            gaEventItems.push({
                affiliation: "Well People",
                currency: "USD",
                discount: 0,
                index: 0,
                item_brand: "Well People",
                item_category: matchingItem.primaryCategory,
                item_id: pid,
                item_list_name: location,
                item_name: matchingItem.productName,
                item_variant: matchingItem.variationAttributes && matchingItem.variationAttribute.length > 0 ? matchingItem.variationAttributes[0].displayValue : '',
                price: matchingItem.priceTotal.priceValue,
                quantity: qty
            })
        } catch (e) {
            console.error('addToCart.js - Error building data for GA event');
        }
    });

    googleAnalytics.genericAddToCartEvent(gaEventItems, 'add_to_cart');

    if (updateCartState) {
        document.body.dispatchEvent(new Event('react:updateCartState'))
    }

    $("#custom-add-to-bag-toast").text(response.message);
    $("#custom-add-to-bag-toast").animate({bottom: "100px"}, 2000, 'swing', () => {
        setTimeout(() => {
            $("#custom-add-to-bag-toast").animate({bottom: "-100px"}, 2000, 'swing');
        }, 3000);
    });
}

function initializeAddToCartEvents() {
    $('body').on('product:addToCart', (e) => {
        if (!e.detail) {
            console.warn('No data for product:addToCart event');
            return;
        }
        handleAddToCart(e.detail, true);
    })
}

module.exports = {
    ...base,
    addToCart: () => {
        baseAddToCart();
        $('body').on('product:beforeAddToCart', (e) => {
            document.querySelectorAll('button.add-to-cart').forEach((butt)=>{
                $(butt).spinner().start();
            });
        });
        $('body').on('product:afterAddToCart', (e) => {
            document.querySelectorAll('button.add-to-cart').forEach((butt)=>{
                $(butt).spinner().stop();
            });
        });
        initializeAddToCartEvents();
    }
}
